<div class="admin-credits-container">
    <div class="header-section">
        <h2>{{ 'admin.components.adminNavigation.credits' | translate }}</h2>
        <p class="subtitle" *ngIf="selectedUser">
            <strong>{{ selectedUser.displayName }}</strong>
        </p>
    </div>

    <div class="main-content">
        <div class="user-specific-content">
            <div class="actions-section">
                <div class="action-cards">
                    <div class="custom-card action-card">
                        <div class="card-header">
                            <h5 class="card-title mb-0">
                                <i class="bi bi-plus-circle"></i>
                                {{
                                    'admin.components.credits.increase.title'
                                        | translate
                                }}
                            </h5>
                        </div>
                        <div class="card-body" *ngIf="selectedUserId">
                            <form
                                [formGroup]="increaseCreditsForm"
                                (ngSubmit)="onIncreaseCredits()"
                            >
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <app-algorithm-input
                                            id="increaseAmount"
                                            inputLabel="{{
                                                'admin.components.credits.increase.amount'
                                                    | translate
                                            }}"
                                            type="text"
                                            [required]="true"
                                            [control]="
                                                increaseCreditsForm.get(
                                                    'amount'
                                                )
                                            "
                                            [decimalPlaces]="7"
                                            (click)="
                                                increaseCreditsForm
                                                    .get('amount')
                                                    .markAsDirty()
                                            "
                                        ></app-algorithm-input>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label
                                            class="label-text"
                                            for="increaseCreditType"
                                            >{{
                                                'admin.components.credits.increase.creditType.label'
                                                    | translate
                                            }}</label
                                        >
                                        <select
                                            class="form-control"
                                            id="increaseCreditType"
                                            formControlName="creditType"
                                        >
                                            <option
                                                [value]="CreditType.INCLUSIVE"
                                            >
                                                {{
                                                    'admin.components.credits.increase.creditType.inclusive'
                                                        | translate
                                                }}
                                            </option>
                                            <option [value]="CreditType.EXTRA">
                                                {{
                                                    'admin.components.credits.increase.creditType.extra'
                                                        | translate
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <label
                                            class="label-text"
                                            for="increaseCause"
                                            >{{
                                                'admin.components.credits.cause'
                                                    | translate
                                            }}</label
                                        >
                                        <textarea
                                            class="form-control"
                                            id="increaseCause"
                                            formControlName="cause"
                                            placeholder="{{
                                                'admin.components.credits.causePlaceholder'
                                                    | translate
                                            }}"
                                            rows="3"
                                        ></textarea>
                                        <div
                                            class="error-div"
                                            *ngIf="
                                                !increaseCreditsForm.get(
                                                    'cause'
                                                ).pristine &&
                                                increaseCreditsForm.get('cause')
                                                    .invalid
                                            "
                                        >
                                            <app-display-errors
                                                [control]="
                                                    increaseCreditsForm.get(
                                                        'cause'
                                                    )
                                                "
                                                [translationKey]="
                                                    'admin.components.credits.error'
                                                "
                                            ></app-display-errors>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-actions">
                                    <button
                                        type="submit"
                                        class="common-button"
                                        [ngClass]="{
                                            disabled:
                                                increaseCreditsForm.invalid ||
                                                isLoading ||
                                                !usersData,
                                        }"
                                        [disabled]="
                                            increaseCreditsForm.invalid ||
                                            isLoading ||
                                            !usersData
                                        "
                                    >
                                        <i class="bi bi-plus"></i>
                                        {{
                                            'admin.components.credits.increase.title'
                                                | translate
                                        }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="custom-card action-card">
                        <div class="card-header">
                            <h5 class="card-title mb-0">
                                <i class="bi bi-dash-circle"></i>
                                {{
                                    'admin.components.credits.decrease.title'
                                        | translate
                                }}
                            </h5>
                        </div>
                        <div class="card-body" *ngIf="selectedUserId">
                            <form
                                [formGroup]="decreaseCreditsForm"
                                (ngSubmit)="onDecreaseCredits()"
                            >
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <div class="form-group col-md-6">
                                            <app-algorithm-input
                                                id="decreaseAmount"
                                                inputLabel="{{
                                                    'admin.components.credits.decrease.amount'
                                                        | translate
                                                }}"
                                                type="text"
                                                [required]="true"
                                                [control]="
                                                    decreaseCreditsForm.get(
                                                        'amount'
                                                    )
                                                "
                                                [decimalPlaces]="7"
                                                (click)="
                                                    decreaseCreditsForm
                                                        .get('amount')
                                                        .markAsDirty()
                                                "
                                            ></app-algorithm-input>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <label
                                            class="label-text"
                                            for="decreaseCause"
                                            >{{
                                                'admin.components.credits.cause'
                                                    | translate
                                            }}</label
                                        >
                                        <textarea
                                            class="form-control"
                                            id="decreaseCause"
                                            formControlName="cause"
                                            placeholder="{{
                                                'admin.components.credits.causePlaceholder'
                                                    | translate
                                            }}"
                                            rows="3"
                                        >
                                        </textarea>
                                        <div
                                            class="error-div"
                                            *ngIf="
                                                !decreaseCreditsForm.get(
                                                    'cause'
                                                ).pristine &&
                                                decreaseCreditsForm.get('cause')
                                                    .invalid
                                            "
                                        >
                                            <app-display-errors
                                                [control]="
                                                    decreaseCreditsForm.get(
                                                        'cause'
                                                    )
                                                "
                                                [translationKey]="
                                                    'admin.components.credits.error'
                                                "
                                            ></app-display-errors>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <div class="form-check">
                                            <app-checkbox
                                                id="isSpendCheck"
                                                inputLabel="{{
                                                    'admin.components.credits.decrease.isSpend'
                                                        | translate
                                                }}"
                                                [control]="
                                                    decreaseCreditsForm.get(
                                                        'isSpend'
                                                    )
                                                "
                                            ></app-checkbox>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-actions">
                                    <button
                                        type="submit"
                                        class="common-button"
                                        [ngClass]="{
                                            disabled:
                                                decreaseCreditsForm.invalid ||
                                                isLoading ||
                                                !usersData,
                                        }"
                                        [disabled]="
                                            decreaseCreditsForm.invalid ||
                                            isLoading ||
                                            !usersData
                                        "
                                    >
                                        <i class="bi bi-dash"></i>
                                        {{
                                            'admin.components.credits.decrease.title'
                                                | translate
                                        }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="custom-card action-card">
                        <div class="card-header">
                            <h5 class="card-title mb-0">
                                <i class="bi bi-arrow-left-right"></i>
                                {{
                                    'admin.components.credits.changeSubscription.title'
                                        | translate
                                }}
                            </h5>
                        </div>
                        <div class="card-body" *ngIf="selectedUserId">
                            <form
                                [formGroup]="changeSubscriptionForm"
                                (ngSubmit)="onChangeSubscription()"
                            >
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <label
                                            class="label-text"
                                            for="subscriptionType"
                                            >{{
                                                'admin.components.credits.subscriptionType.label'
                                                    | translate
                                            }}</label
                                        >
                                        <select
                                            class="form-control"
                                            id="subscriptionType"
                                            formControlName="subscriptionType"
                                        >
                                            <option
                                                [value]="SubscriptionType.FREE"
                                            >
                                                {{
                                                    'admin.components.credits.subscriptionType.free'
                                                        | translate
                                                }}
                                            </option>
                                            <option
                                                [value]="
                                                    SubscriptionType.STARTER
                                                "
                                            >
                                                {{
                                                    'admin.components.credits.subscriptionType.starter'
                                                        | translate
                                                }}
                                            </option>
                                            <option
                                                [value]="
                                                    SubscriptionType.SINGLE_USER
                                                "
                                            >
                                                {{
                                                    'admin.components.credits.subscriptionType.singleUser'
                                                        | translate
                                                }}
                                            </option>
                                            <option
                                                [value]="SubscriptionType.TEAM"
                                            >
                                                {{
                                                    'admin.components.credits.subscriptionType.team'
                                                        | translate
                                                }}
                                            </option>
                                            <option
                                                [value]="
                                                    SubscriptionType.EDUCATION
                                                "
                                            >
                                                {{
                                                    'admin.components.credits.subscriptionType.education'
                                                        | translate
                                                }}
                                            </option>
                                            <option
                                                [value]="
                                                    SubscriptionType.UNLIMITED
                                                "
                                            >
                                                {{
                                                    'admin.components.credits.subscriptionType.unlimited'
                                                        | translate
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <label
                                            class="label-text"
                                            for="changeType"
                                            >{{
                                                'admin.components.credits.changeSubscription.changeType.label'
                                                    | translate
                                            }}
                                            <img
                                                src="assets/svg/algorithm/info-hover.svg"
                                                alt="Info"
                                                class="info-icon"
                                                title="{{
                                                    'admin.components.credits.changeSubscription.changeType.info'
                                                        | translate
                                                }}"
                                        /></label>
                                        <select
                                            class="form-control"
                                            id="changeType"
                                            formControlName="changeType"
                                        >
                                            <option
                                                [value]="
                                                    SubscriptionChangeType.PERIOD_END
                                                "
                                            >
                                                {{
                                                    'admin.components.credits.changeSubscription.changeType.periodEnd'
                                                        | translate
                                                }}
                                            </option>
                                            <option
                                                [value]="
                                                    SubscriptionChangeType.SUBSCRIPTION_END
                                                "
                                            >
                                                {{
                                                    'admin.components.credits.changeSubscription.changeType.subscriptionEnd'
                                                        | translate
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <app-algorithm-input
                                            id="prepaidPeriods"
                                            inputLabel="{{
                                                'admin.components.credits.changeSubscription.prepaidPeriods'
                                                    | translate
                                            }}"
                                            type="text"
                                            [required]="false"
                                            [allowEmptyValue]="true"
                                            [control]="
                                                changeSubscriptionForm.get(
                                                    'prepaidPeriods'
                                                )
                                            "
                                            [isFloatingPoint]="false"
                                            (click)="
                                                changeSubscriptionForm
                                                    .get('prepaidPeriods')
                                                    .markAsDirty()
                                            "
                                        ></app-algorithm-input>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <div class="form-check">
                                            <app-checkbox
                                                id="isAutoRenew"
                                                inputLabel="{{
                                                    'admin.components.credits.userOverview.isAutoRenew'
                                                        | translate
                                                }}"
                                                [control]="
                                                    changeSubscriptionForm.get(
                                                        'isAutoRenew'
                                                    )
                                                "
                                            ></app-checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-actions">
                                    <button
                                        type="submit"
                                        class="common-button"
                                        [ngClass]="{
                                            disabled:
                                                changeSubscriptionForm.invalid ||
                                                isLoading ||
                                                !selectedUserId,
                                        }"
                                        [disabled]="
                                            changeSubscriptionForm.invalid ||
                                            isLoading ||
                                            !selectedUserId
                                        "
                                    >
                                        <i class="bi bi-arrow-left-right"></i>
                                        {{
                                            'admin.components.credits.changeSubscription.title'
                                                | translate
                                        }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="custom-card users-table-card">
                <div class="card-header">
                    <h5 class="card-title mb-0">
                        {{
                            'admin.components.credits.userOverview.title'
                                | translate
                        }}
                    </h5>
                </div>
                <div class="card-body" *ngIf="usersData">
                    <div class="table-responsive">
                        <table
                            class="table table-striped table-hover users-table"
                        >
                            <thead class="table-dark">
                                <tr>
                                    <th>
                                        {{
                                            'admin.components.credits.userOverview.inclusive'
                                                | translate
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            'admin.components.credits.userOverview.extra'
                                                | translate
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            'admin.components.credits.userOverview.used'
                                                | translate
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            'admin.components.credits.userOverview.blocked'
                                                | translate
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            'admin.components.credits.userOverview.available'
                                                | translate
                                        }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ usersData.inclusive }}</td>
                                    <td>{{ usersData.extra }}</td>
                                    <td>{{ usersData.used }}</td>
                                    <td>{{ usersData.blocked }}</td>
                                    <td>{{ usersData.available }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div
                        class="table-responsive"
                        *ngIf="usersData.currentSubscription"
                    >
                        <table
                            class="table table-striped table-hover users-table"
                        >
                            <thead class="table-dark">
                                <tr>
                                    <th>
                                        {{
                                            'admin.components.credits.subscriptionType.label'
                                                | translate
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            'admin.components.credits.userOverview.subscriptionStart'
                                                | translate
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            'admin.components.credits.userOverview.subscriptionEnd'
                                                | translate
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            'admin.components.credits.userOverview.periodStart'
                                                | translate
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            'admin.components.credits.userOverview.periodEnd'
                                                | translate
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            'admin.components.credits.userOverview.remainingPrepaidPeriods'
                                                | translate
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            'admin.components.credits.userOverview.isAutoRenew'
                                                | translate
                                        }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {{
                                            usersData.currentSubscription
                                                .subscriptionType
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            usersData.currentSubscription
                                                .startDate | date: 'dd.MM.yyyy'
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            usersData.currentSubscription
                                                .endDate | date: 'dd.MM.yyyy'
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            usersData.currentSubscription
                                                .periodStartDate
                                                | date: 'dd.MM.yyyy'
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            usersData.currentSubscription
                                                .periodEndDate
                                                | date: 'dd.MM.yyyy'
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            usersData.currentSubscription
                                                .remainingPrepaidPeriods
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            usersData.currentSubscription
                                                .isAutoRenew
                                        }}
                                    </td>
                                </tr>
                                <tr *ngIf="usersData.nextSubscription">
                                    <td>
                                        {{
                                            usersData.nextSubscription
                                                .subscriptionType
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            usersData.nextSubscription.startDate
                                                | date: 'dd.MM.yyyy'
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            usersData.nextSubscription.endDate
                                                | date: 'dd.MM.yyyy'
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            usersData.nextSubscription
                                                .periodStartDate
                                                | date: 'dd.MM.yyyy'
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            usersData.nextSubscription
                                                .periodEndDate
                                                | date: 'dd.MM.yyyy'
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            usersData.nextSubscription
                                                .remainingPrepaidPeriods
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            usersData.nextSubscription
                                                .isAutoRenew
                                        }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="user-list-section">
            <div class="custom-card user-list-card">
                <div class="card-header">
                    <h5 class="card-title mb-0">
                        {{ 'admin.components.credits.selectUser' | translate }}
                    </h5>
                </div>
                <div class="card-body">
                    <div class="user-list" *ngIf="!isLoading">
                        <div
                            class="user-item"
                            *ngFor="let user of users"
                            [class.selected]="selectedUser?.id === user.id"
                            (click)="onUserSelect(user)"
                        >
                            <div class="user-info">
                                <div
                                    class="user-name"
                                    [title]="user.displayName"
                                >
                                    {{ user.displayName }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="isLoading" class="loading-overlay">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-3">
                {{ 'admin.components.credits.loading' | translate }}
            </p>
        </div>
    </div>
</div>
